// `useDebouncedValue` — Wave D11 (US-142).
//
// Returns a value that lags `value` by `delayMs`. Each new write resets
// the timer, so a flurry of keystrokes only emits the final settled
// value to subscribers (typically a react-query `queryKey`). When `delayMs`
// is `0` the input value is forwarded synchronously — handy for tests.

import { useEffect, useState } from 'react';

export function useDebouncedValue<T>(value: T, delayMs: number): T {
  const [debounced, setDebounced] = useState(value);

  useEffect(() => {
    if (delayMs <= 0) {
      setDebounced(value);
      return;
    }
    const handle = setTimeout(() => setDebounced(value), delayMs);
    return () => clearTimeout(handle);
  }, [value, delayMs]);

  return debounced;
}
